import { _ } from "../../core/polyglot/polyglot.js";
import externalDocument from "../shared/externalDocument.js";
import jQuery from "jquery";
import userService from "../../core/services/userService.js";

/**
 *	`recoverPasswordDocument' is a simple document asking for the
 *	user's username in order to provide him/her a new password.
 *
 *	POST: /External/Authenticate/ResetPassword
 */

/**
 * Todo: Add JSDoc comment
 */
function recoverPasswordDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.title = _("Reset password");

	let username = "";

	function renderUserNameOn(html) {
		html.input({
			id: "username",
			name: "username",
			type: "text",
			class: "form-control input-lg",
			placeholder: _("Username"),
		});
	}

	function renderSendOn(html) {
		html.span(
			{ class: "input-group-btn" },
			html.button(
				{
					type: "submit",
					id: "reset-password-button",
					class: "login-button btn btn-lg btn-primary",
					"data-test": "recover",
				},
				_("Send"),
			),
		);
	}

	function renderBackOn(html) {
		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-sm-12" },
				html.div(
					{ class: "forgot-link" },
					html.a(
						{ href: my.linkTo("login", {}) },
						_("Or take me back to the login page"),
					),
				),
			),
		);
	}

	function renderErrorsOn(html) {
		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-sm-12 text-center" },
				html.div({ id: "errors" }),
			),
		);
	}

	my.renderContentOn = function (html) {
		html.div({ id: "document-title" }, html.h1(that.title));

		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-lg-4 col-lg-offset-4 col-sm-6 col-sm-offset-3" },
				html.p(
					{ class: "lead" },
					_(
						'So, you forgot it, did you? No need to worry! Just submit your user name in the form below and we\'ll send you a new one quicker than it takes you to say {emphasize: "Current investments and liquid funds to net sales ratio"...}',
						{
							emphasize: (text) => (html) => html.em(text),
						},
					),
				),
				html.div(
					{ class: "panel login-panel" },
					html.div(
						{ class: "panel-body" },
						html
							.form(
								{
									id: "reset-password-form",
								},
								html.div(
									{ class: "input-group" },
									renderUserNameOn,
									renderSendOn,
								),
								renderErrorsOn,
								renderBackOn,
							)
							.submit((event) => {
								event.preventDefault();
								submitUsername();
							}),
					),
				),
			),
		);
	};

	my.getErrorMessage = function (errorResponse) {
		const errorMessage = errorResponse?.responseJSON?.message;

		switch (errorMessage) {
			case "The password can only be reset by the administrator, please contact support": {
				return _(
					"The password can only be reset by the administrator, please contact support.",
				);
			}
			case "Could not reset password": {
				return _(
					"Could not reset the password or the user is not found.",
				);
			}

			case "can not find the anti forgery token": {
				return _("Cannot find the anti-forgery token");
			}

			default: {
				return _("An unknown error '{unknownError}' was received", {
					unknownError: errorMessage,
				});
			}
		}
	};

	function submitUsername() {
		username = jQuery("#username").val();
		resetPassword();
	}

	function resetPassword() {
		userService.resetPassword({
			username,
			onSuccess: redirectToPasswordReset,
			onError,
		});
	}

	function onError(errorResponse) {
		const errorMessage = my.getErrorMessage(errorResponse);
		const errorsDiv = jQuery("#errors");
		errorsDiv.empty();
		errorsDiv.append(errorMessage.toString());
		errorsDiv.addClass("alert alert-danger");
	}

	function redirectToPasswordReset() {
		my.redirectTo("reset");
	}

	return that;
}

export default recoverPasswordDocument;
